import React from 'react'
import '../../../Styles/WatchPage/Comments/Comments.css'
import { Sort } from '@material-ui/icons'
import AddComments from './AddComments'

function Comments() {
    return (
        <div className='video-comments--container'>
            <div className='video-comments__count-sort'> 
                <div className='video-comments__count-sort__count'>
                    25 Comments
                </div>
                <div className='video-comments__count-sort__sort'>
                    <div className='video-comments__count-sort__sort--icon'>
                        <Sort />
                    </div>
                    Sort
                </div>
            </div>
            <div className='video-comments__add-comments--container'>
                <AddComments />
            </div>
        </div>
    )
}

export default Comments
